import React, {PropsWithChildren, useContext} from 'react';
import {StepContentContext} from './step-content-context';
import styles from './styles.module.less';
import {join} from '@esgi/ui-kit/utils';

type Props = {
	headerTitleRef?: React.RefObject<HTMLDivElement>
	onClick?: () => void
} & PropsWithChildren;

export function StepHeader({headerTitleRef, onClick, children}: Props) {
	const context = useContext(StepContentContext);
	return <div className={join(styles.stepHeader, styles.paddingContainer)} onClick={onClick}>
		<div className={join(styles.index, context.active && styles.active)}>{context.index}</div>
		<div className={join(styles.title, context.active && styles.active)} ref={headerTitleRef}>{children}</div>
	</div>;
}
